import { BaseApiConfig } from "@/Service/Api/V1/BaseApiConfig";
import { ExportsApi } from "@/Stub/V1";

export const ExportsApiClient = new ExportsApi(BaseApiConfig);